export function isEmpty(obj: Record<string, any> | null = {}): boolean {
  return !!obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function insertArrayAt<T>(array: T[], index: number, value: T): T[] {
  return [...array.slice(0, index), value, ...array.slice(index)];
}

export function escapeRegExp(text: string): string {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
